import Seo from '../../components/Seo/Seo';
import BlogListSection from '../../components/Blog/BlogListSection';

const BlogPage = () => {
  return (
    <>
      <Seo
        title="Blog – Webentwicklung, Apps & Design | Nexite IT"
        description="Fachbeiträge rund um Webentwicklung, App-Entwicklung, UI/UX Design und Online-Marketing – aus der Praxis unserer Kölner Agentur."
        path="/blog"
      />
      <BlogListSection />
    </>
  );
};

export default BlogPage;
